import { Feature, Geometry } from '@turf/turf';
import * as turf from '@turf/turf';
import { VehicleActivity } from './vehicle';

export class Stop {
    stopId: string;
    stopDescription: string;
    platformCode: string;
    geoJson: string;
    geo: Geometry;
    position: [number, number];

    vehicleActivities: VehicleActivity[];

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (this.geoJson) {
            try {
                this.geo = JSON.parse(this.geoJson);
            } catch (error) {
                console.log(`could not parse geoJson JSON for activityPoint, stopDescription: ${this.stopDescription}`)
            }
        }

        if (!this.position && this.geo) {
            this.position = [this.geo.coordinates[0] as number, this.geo.coordinates[1] as number];
        }
    }

    public toFeature(isSelected: boolean = false): Feature {
        if (this.position) {

        }

        if (!this.geo) {
            return undefined;
        }

        const properties = {
            id: this.stopId,
            title: this.stopDescription + (this.platformCode ? ` ${this.platformCode}` : ''),
            zIndex: 10,
            type: 'point'
        };

        if (isSelected) {
            const selectionProperties = this._createSelectionProperties();
            Object.assign(properties, selectionProperties);
        }

        const feature = turf.feature(this.geo, properties);
        return feature;
    }

    private _createSelectionProperties(): any {
        const properties: any = {};
        properties.isSelected = true;
        properties.zIndex = 30;
        return properties;
    }
}
